import PropTypes from "prop-types";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

const TextList = (props) => {
  const { listItems, sx, center } = props;

  return (
    <List dense sx={{ p: 0, ...sx }}>
      {listItems.map((l) => (
        <ListItem
          key={l.id}
          sx={{
            p: 0.1,
            justifyContent: center ? "center" : "unset",
            display: center ? "contents" : "flex", // was 'contents' but makes rows stay on same line; not sure what that was for
          }}
        >
          {l.content}
        </ListItem>
      ))}
    </List>
  );
};

TextList.defaultProps = { sx: {} };
TextList.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  sx: PropTypes.object,
};

export default TextList;
